import { useQueryClient } from 'react-query';
import { QueryKeys } from 'constants/queryKeys';

export const useGetBlockedState = () => {
  const queryClient = useQueryClient();

  return queryClient.getQueryData(QueryKeys.userBlocked);
};
